import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UserPassword } from "@user-management-context/write/domain/types/user";

export const updatePassword = createApiThunk<void, UserPassword>(
  "users/updatePassword",
  async (body: UserPassword, { extra: { publicRepository } }) => {
    return publicRepository!.updatePassword(body);
  },
);

export const resetUpdatePassword = createAction("user/resetUpdatePassword");
